import { render } from "./PostNode.vue?vue&type=template&id=93322ad6&scoped=true&ts=true"
import script from "./PostNode.vue?vue&type=script&lang=ts"
export * from "./PostNode.vue?vue&type=script&lang=ts"

import "./PostNode.vue?vue&type=style&index=0&id=93322ad6&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\miauerka\\web-projects\\mimafi-project\\mimawebapp\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-93322ad6"]])

export default __exports__